import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

// El backend responde { data, state, message }: un fallo de negocio llega con
// state=false y HTTP 200, así que se convierte en excepción para el toast.
const resultado = (data) => {
  if (data?.state === false) throw new Error(data?.message || 'No fue posible completar la acción');
  return data?.data;
};

export const getAusencias = async (params = {}) => {
  const { data } = await axios.get(`${API_URL}/ausencias`, { params });
  return resultado(data) || [];
};

export const crearAusencia = async (payload) => {
  const { data } = await axios.post(`${API_URL}/ausencias`, payload);
  return resultado(data);
};

export const actualizarAusencia = async (id, payload) => {
  const { data } = await axios.patch(`${API_URL}/ausencias/${id}`, payload);
  return resultado(data);
};

export const anularAusencia = async (id, payload) => {
  const { data } = await axios.patch(`${API_URL}/ausencias/${id}/anular`, payload);
  return resultado(data);
};
